import React from 'react';
import logo from './Objeto.svg';

export default function VideoLogo() {
  return <img src={logo} alt="Logo" />;
}
